export default function Price({ children, currency = "€" }) {
  return (
    <span>
      <span>{currency}&nbsp;</span>
      <span>
        {Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(children)}
      </span>
    </span>
  );
}
